export default {
  countryCode: 'IN',
  regionLinks: [
    {
      title: 'Mumbai',
    },
  ],
};
